import { render, staticRenderFns } from "./tailor.vue?vue&type=template&id=74e0ac33&"
import script from "./tailor.vue?vue&type=script&lang=js&"
export * from "./tailor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports